import React, { Fragment, useMemo } from "react"
import { useCategories } from "../../../../hooks/apiHooks/useCategories";
import { PLATFORMS_KEY, SOCIALS_KEY } from "../../../../enums/generalEnums";
import { addRemoveArray, filterArray } from "../../../../helpers/arrayHelper";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { Grid } from "@mui/system";
import { CheckSquare, Square } from "@phosphor-icons/react";

export const PlatformsAndSocials = (props) => {

  const {
    platformsSelected,
    socialsSelected,
    setPlatformsSelected,
    setSocialsSelected,
    storeKey = 'id'
  } = props;

  const { data: platformsAndSocials } = useCategories({ type: [SOCIALS_KEY, PLATFORMS_KEY] }, 'platformsAndSocials');

  const renderPlatformsAndSocials = useMemo(() => {
    return {
      [PLATFORMS_KEY]: filterArray(platformsAndSocials, PLATFORMS_KEY, 'type'),
      [SOCIALS_KEY]: filterArray(platformsAndSocials, SOCIALS_KEY, 'type')
    }
  }, [platformsAndSocials])

  const handleSelectCategory = (key, isAdd = true, isPlatform = true) => {
    if (isPlatform) {
      setPlatformsSelected((prev) => addRemoveArray(prev, isAdd, key));
    } else {
      setSocialsSelected((prev) => addRemoveArray(prev, isAdd, key));
    }
  };

  return (
    <Fragment>
      <Typography variant="subtitle1" fontWeight={700}>Platform</Typography>
      <Grid container>
        {
          renderPlatformsAndSocials?.platforms?.map((platform, index) => {
            const isSelected = platformsSelected?.includes(platform?.[storeKey]);
            return (
              <Grid key={`platform-key-${index}`} item size={{ xs: 12, sm: 3 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelected}
                      icon={<Square size={24} color="#919EAB" />}
                      checkedIcon={<CheckSquare size={24} weight="fill" />}
                      onChange={(event) => handleSelectCategory(platform?.[storeKey], event.target.checked)}
                    />
                  }
                  label={platform?.name}
                />
              </Grid>
            )
          })
        }
      </Grid>

      <Typography variant="subtitle1" fontWeight={700}>Social</Typography>
      <Grid container>
        {
          renderPlatformsAndSocials?.socials?.map((social, index) => {
            const isSelected = socialsSelected?.includes(social?.[storeKey]);
            return (
              <Grid key={`social-key-${index}`} item size={{ xs: 12, sm: 3 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelected}
                      icon={<Square size={24} color="#919EAB" />}
                      checkedIcon={<CheckSquare size={24} weight="fill" />}
                      onChange={(event) => handleSelectCategory(social?.[storeKey], event.target.checked, false)}
                    />
                  }
                  label={social?.name}
                />
              </Grid>
            )
          })
        }
      </Grid>
    </Fragment>
  )
};